import React from 'react';
import { useLocation } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import { AlertCircle, CheckCircle } from 'lucide-react';

const LoginPage = () => {
  const location = useLocation();
  const passwordResetSuccess = location.state?.passwordResetSuccess;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Main Login Card */}
        <div className="bg-card border border-border rounded-lg shadow-elevated p-8">
          <LoginHeader />
          {passwordResetSuccess && (
            <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-md flex items-start">
              <CheckCircle className="text-green-600 mr-2 mt-0.5 flex-shrink-0" size={20} />
              <div>
                <p className="text-green-800 text-sm font-medium">Password Reset Successful</p>
                <p className="text-green-700 text-sm mt-1">Your password has been reset. You can now sign in with your new password.</p>
              </div>
            </div>
          )}
          <LoginForm />
          {/* <SecurityBadges /> */}
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} ExpenseLoop. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
